module.exports = __webpack_public_path__ + "img/edt dis.743518a7.svg";